module.exports = __webpack_public_path__ + "img/what-we-sell_0007.fe67446d.jpg";